import { Field } from 'formik';
import { RadioGroup } from 'formik-material-ui';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
} from '@material-ui/core';
import { OFF, ON } from 'consts';

const radio = <Radio color="primary" />;

const ContentMultiplePayment = () => {
  return (
    <FormControl>
      <FormLabel>Did the user send the payment multiple times?</FormLabel>
      <Field component={RadioGroup} name="paymentSentMultipleTimesOffOn" row>
        <FormControlLabel control={radio} label="Yes" value={ON} />
        <FormControlLabel control={radio} label="No" value={OFF} />
      </Field>
    </FormControl>
  );
};

export default ContentMultiplePayment;
